import React from 'react';
import { Link } from 'react-router-dom';
import { isEmpty } from 'ramda';

import HighlightedBoardgame from './HighlightedBoardgame';

const BoardgamesSelectionHero = ({ boardgames }) => {
  return (
    <React.Fragment>
      {
        !isEmpty(boardgames) &&
          <div className="sg-boardgames-selection">
            <div className="w-screen mb-2 md:mb-4 px-4 md:px-20">
              <h1 className="font-serif text-2xl md:text-4xl font-black leading-tight">Smart Gaming Selection</h1>
            </div>
            <div className="touch overflow-x-auto w-screen mb-4">
              <div className="flex flex-row float-left px-4 md:px-20 pt-4 pb-12 sizing-border">
                {
                  boardgames.map(bg => 
                    <Link key={bg.id} className="sg-selection-bg" to={`/boardgames/${bg.id}`}>
                      <HighlightedBoardgame {...bg} />
                    </Link>
                  )
                }
              </div>
            </div>
          </div>
      }
    </React.Fragment>
  );
};

export default BoardgamesSelectionHero;
